import React from 'react';

import { Box, Chip, SxProps, Theme, Typography } from '@mui/material';

import { spaces } from '../../../../../assets/styles/themes/tokens';
import getTextTruncationSx from '../../../../../utils/getTextTruncationSx';
import Tooltip from '../../../../Tooltip';
import { useTranslation } from 'react-i18next';

const MuiCardBaseLongHeader: React.FC<{
    primaryText: string;
    secondaryText?: string;
    enableSecondaryTextTooltip?: boolean;
    showReadOnlyChip?: boolean;
    customReadOnlySx?: SxProps<Theme>;
  }> = ({ primaryText, secondaryText, enableSecondaryTextTooltip, showReadOnlyChip }) => {
    const { t } = useTranslation();
    return (
      <Box
        sx={{
          gap: spaces.sm,
          display: 'flex',
          alignItems: 'baseline',
          paddingRight: spaces.xxxl,
        }}
        data-testid='mui-card-desktop__right-content-header'
      >
        <Typography
          variant='overline'
          color='text.secondary'
          textTransform='uppercase'
          sx={{ flexShrink: 0 }}
        >
          {primaryText}
        </Typography>
        {
          secondaryText && <>
            <Typography variant='caption' color='text.secondary'>
          •
            </Typography>
            {enableSecondaryTextTooltip ? (
              <Tooltip label={secondaryText} placement='top'>
                <Typography
                  variant='caption'
                  color='text.secondary'
                  sx={getTextTruncationSx(1)}
                >
                  {secondaryText}
                </Typography>
              </Tooltip>
            ) : (
              <Typography variant='caption' color='text.secondary'>
                {secondaryText}
              </Typography>
            )}
          </>
        }
        { showReadOnlyChip && <Chip label={t('Read only')} /> }
      </Box>
    );
  };

export default MuiCardBaseLongHeader;
